define('viewmodels/ActionTracker/ActionItemDetails',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'viewmodels/ActionTracker/ActionItemDashboard', 'services/utils', 'viewmodels/ActionTracker/ActionTracking', 'viewmodels/ActionTracker/ActionPlanDetails', 'viewmodels/ActionTracker/ConfigureActionTracker'], function (ko, router, app, appsecurity, navigation, system, logger, ActionItemDashboardVM, utils, ActionTrackingVM, ActionPlanDetailsVM, vm) {
    var ActionItemDetailsVM = {
        title: ko.observable("Action Item Details"),
        attached: attached,
        activate: activate,
        deactivate: deactivate,
        dettached: dettached,
        appsecurity: appsecurity,
        logger: logger,
        ActionItemNumber:ko.observable(),
        utils: utils,
        SaveComment: SaveComment,
        ActionItemDashboardVM: ActionItemDashboardVM,
        ActionTrackingVM: ActionTrackingVM,
        ActionPlanDetailsVM: ActionPlanDetailsVM,
        vm: vm,
        CommentText: ko.observable(),
        ActionItemId: ko.observable(),
        RoleId: ko.observable(),
        CommentList: ko.observableArray([]),
        ResponseMoveArrayItem: ko.observableArray([]),
        ActionItemActionsList: ko.observableArray([]),
        DocumentList: ko.observableArray([]),
        UploadDocument: UploadDocument,
        UpdateStatus: UpdateStatus,
        DocPath: ko.observable(),
        DocId: ko.observable(),
        Assignees: ko.observableArray(),
        Reviewers: ko.observableArray(),
        EventId: ko.observableArray(),
        CompletedList: ko.observableArray(),
        CompletedFlag: ko.observable(),
        IsComposeFlag: ko.observable(),
        DownloadDocument: DownloadDocument,
        NavigateToDashboard: NavigateToDashboard,
        NavigateToManagement: NavigateToManagement,
        NavigateToActiontracking: NavigateToActiontracking,
        UpdateActionItemStatus: UpdateActionItemStatus,
        EstimatedStartDate: ko.observable(),
        EstimatedEndDate: ko.observable(),
        Status: ko.observable(),
        ActionItemDetailsList: ko.observable(new ActionItemDetailsModel({ ActionItemTitle: null, ActionItemDescription: null, ControlArea: null, ControlDescription: null, Response: null, BusinessUnit: null })),
        IsCompose: ko.observable(0),
        TabClick: TabClick,
        Tablist: ko.observableArray([]),
        PushbackComment: ko.observable(),
        rsfPopUpTitle: ko.observable('Edit Action Details'),
        PushbackComment: ko.observable(),
        PerformSelectedAction: PerformSelectedAction,
        ScreenName: ko.observable(),
        SurveyCommentList: ko.observableArray([]),
        SurveyDocumentList:ko.observableArray([]),
        DownloadSurveyDocument: DownloadSurveyDocument,
        SurveyFinalizeCommentList: ko.observableArray([]),
        ActionPlanId: ko.observable(),
        BackToAPDetails: BackToAPDetails,
        ResponseBackArray: ko.observableArray([]),
        IsActionFlag: ko.observable(),
        ActionDisplayNumber: ko.observable(""),
        ActionFlagType: ko.observable(),
        DeleteDocument: DeleteDocument,
        AttachmentComment: ko.observable(""),
    };
    return ActionItemDetailsVM;

    function attached() {
        try {
            $('#detailsdiv').show();
            ActionItemDetailsVM.DocPath("");
            if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Plan" && ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem() != undefined && ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().length != 0) {
                    ActionItemDetailsVM.ActionPlanId(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionPlanId());
                    ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionItemId());
                    ActionItemDetailsVM.IsActionFlag("Plan");
                    ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().CompletedFlag());
                    ActionItemDetailsVM.RoleId(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().RoleId());
                    ActionItemDetailsVM.ActionFlagType("Plan Detail");
                    ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionItemNumber());
            } else if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Item" && ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray() != undefined && ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().length != 0) {
            ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().ActionItemId());
            ActionItemDetailsVM.RoleId(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().RoleId());
            ActionItemDetailsVM.IsActionFlag("Item");
            ActionItemDetailsVM.ActionFlagType("Item");
            ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().CompletedFlag());
                ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().ActionItemNumber());
                ActionItemDetailsVM.IsComposeFlag(2);
            }
            else if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Item" && ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray() != undefined && ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().length != 0) {
                ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().ActionItemId());
                ActionItemDetailsVM.RoleId(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().RoleId());
                ActionItemDetailsVM.IsActionFlag("Item");
                ActionItemDetailsVM.ActionFlagType("Create");
                ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().CompletedFlag());
                ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().ActionItemNumber());
                ActionItemDetailsVM.IsComposeFlag(3);
            }
            else if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Create" && ActionItemDetailsVM.vm.ActionItemDashboardVM != undefined && ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray() != undefined && ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().length != 0) {
                ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().ActionItemId());
                ActionItemDetailsVM.IsActionFlag("Item");
                ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().ActionItemNumber());
                ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().CompletedFlag());
                ActionItemDetailsVM.IsComposeFlag(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().IsComposeFlag());
                ActionItemDetailsVM.RoleId(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().RoleId());
                ActionItemDetailsVM.ActionFlagType("Create");
            }
                else {
                    router.navigate("#ActionTracker/ActionPlanManagement", true);
                    logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionItemDetailsVM), true);
                }
             $("#ActionItemDocuments").hide();
            GetDocuments();
            $("#ScreennameSurvey").html("Action Item Details (<i>" + ActionItemDetailsVM.ActionDisplayNumber() + "</i>)");
                if ($('ul#Itemdetailstab li').length == 1) {
                    var element = $('#ActionItemDetailTabSection')[0];
                    ko.cleanNode(element);
                    ko.applyBindings(ActionItemDetailsVM, document.getElementById('ActionItemDetailTabSection'));
                }

                ActionItemDetails();
                GetSurveyComments();
                GetComments();
                GetallSurveyPushBackComments();
                GetallSurveyDocuments();
                GetActionItemAction();
                $('#ActionItemDetailTabSection').tabs();
                $('#ActionItemDetailTabSection').tabs('refresh');
                $('#ActionItemDetailTabSection').tabs({ active: 0 });
                $($('#ActionItemDetailTabSection li').get(0)).trigger('click');
                //$("#CommenttextItem").jqte();
            $("#FinalizeComment").val('');
           

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    };

    
    function BackToAPDetails(data, event) {
        try {
            router.navigate("#ActionTracker/ActionPlanDetails", true);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | BackToAPDetails() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function ResponseBackModel(item) {
        try {
            var self = this;
            self.ActionPlanId = ko.observable(item.ActionPlanId);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function TabClick(data, event) {
        try {
            $('#Itemdetailstab li').removeClass('active');
            $('#' + event.currentTarget.id).addClass('active');
            $('#valcommenterror').hide();
            $('#valfactorerror').hide();
            if (event.currentTarget.id == "Details") {
                Hidealldivs("detailsdiv");
            }
            else if (event.currentTarget.id == "Documents") {
                Hidealldivs("Documentsdiv");
            }
            else if (event.currentTarget.id == "Comments") {
                Hidealldivs("commentsdiv");
            }
            else if (event.currentTarget.id == "Actions") {
                Hidealldivs("Actionsdiv");
            }
            else if (event.currentTarget.id=="Attachment")
            {
                Hidealldivs("Attachmentdiv");
            }

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | TabClick() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function Hidealldivs(i)
    {
        $("#detailsdiv").hide();
        $("#commentsdiv").hide();
        $("#Documentsdiv").hide();
        $("#Actionsdiv").hide();
        $("#Attachmentdiv").hide();
        $("#" + i).show();
    }
    function activate(DataObj) {
        try {
            ActionItemDetailsVM.DocPath("");
            if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Plan" && ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem() != undefined && ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().length != 0) {
                    ActionItemDetailsVM.ActionPlanId(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionPlanId());
                    ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionItemId());
                    ActionItemDetailsVM.IsActionFlag("Plan");
                    ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().CompletedFlag());
                    ActionItemDetailsVM.RoleId(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().RoleId());
                    ActionItemDetailsVM.ActionFlagType("Plan Detail");
                    ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionItemNumber());
            }
            else if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Item" && ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray() != undefined && ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().length != 0) {
                ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().ActionItemId());
                ActionItemDetailsVM.RoleId(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().RoleId());
                ActionItemDetailsVM.IsActionFlag("Item");
                ActionItemDetailsVM.ActionFlagType("Create");
                ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().CompletedFlag());
                ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.ActionTrackingVM.ResponseMoveArray().ActionItemNumber());
                ActionItemDetailsVM.IsComposeFlag(3);
            } else if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Item" && ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray() != undefined && ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().length != 0) {
            ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().ActionItemId());
            ActionItemDetailsVM.RoleId(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().RoleId());
            ActionItemDetailsVM.IsActionFlag("Item");
            ActionItemDetailsVM.ActionFlagType("Item");
            ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().CompletedFlag());
                ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.ActionItemDashboardVM.ResponseMoveArray().ActionItemNumber());
                ActionItemDetailsVM.IsComposeFlag(2);
        }
            else if (ActionItemDetailsVM.appsecurity.ActionFlagType() == "Create" && ActionItemDetailsVM.vm.ActionItemDashboardVM != undefined && ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray() != undefined && ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().length != 0) {
                ActionItemDetailsVM.ActionItemId(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().ActionItemId());
                ActionItemDetailsVM.IsActionFlag("Item");
                ActionItemDetailsVM.ActionDisplayNumber(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().ActionItemNumber());
                ActionItemDetailsVM.CompletedFlag(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().CompletedFlag());
                ActionItemDetailsVM.IsComposeFlag(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().IsComposeFlag());
                ActionItemDetailsVM.RoleId(ActionItemDetailsVM.vm.ActionItemDashboardVM.ResponseMoveArray().RoleId());
                ActionItemDetailsVM.ActionFlagType("Create");
            }
                else {
                    router.navigate("#ActionTracker/ActionPlanManagement", true);
                    logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionItemDetailsVM), true);
                }
                ActionItemDetailsVM.Tablist([]);
                
                var tabs3 = { listname: "Status", ElementId: "Details" }
                var tabs = { listname: "Attachments", ElementId: "Documents" }
                var tabs1 = { listname: "Comments", ElementId: "Comments" }
                var tabs4 = { listname: "Response Details", ElementId: "Attachment" }
                ActionItemDetailsVM.Tablist().push(tabs3);
                ActionItemDetailsVM.Tablist().push(tabs);
                ActionItemDetailsVM.Tablist().push(tabs1);
                ActionItemDetailsVM.Tablist().push(tabs4);

                if (ActionItemDetailsVM.CompletedFlag() == false) {
                    var tabs2 = { listname: "Finalize", ElementId: "Actions" }

                    ActionItemDetailsVM.Tablist().push(tabs2);
                }
               
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    };
    function deactivate() {
        try {

            var x = "temp";
            ActionItemDetailsVM.Tablist([]);
            var element = $('#ActionItemDetailTabSection')[0];
            ko.cleanNode(element);
            ko.applyBindings(ActionItemDetailsVM, document.getElementById('Itemdetailstab'));
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    };
    function dettached() {
        try {
            var x = "temp2"
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    };

    function SaveComment() {
        try {
            //ActionItemDetailsVM.CommentText($('#CommenttextItem').parent().parent().children().closest('[class^="jqte_editor"]').html());
            ActionItemDetailsVM.CommentText($('#TextComment').val());
            if (ActionItemDetailsVM.CommentText() != null && ActionItemDetailsVM.CommentText() != '' && ActionItemDetailsVM.CommentText() != undefined){
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/ActionPlan/SaveComment",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify({ ActionItemId: ActionItemDetailsVM.ActionItemId(), CommentAction: 'I', CommentId: null, CommentText: ActionItemDetailsVM.CommentText() })

                })
     .success(function (jsonResult, success) {
         document.getElementById('valfactorerror').innerHTML = "Please enter a comment.";
         $('#valcommenterror').hide();
         ActionItemDetailsVM.CommentText([]);
         if (jsonResult != null) {
             logger.logSuccess('Comment has been saved successfully.', 'Success', system.getModuleId(ActionItemDetailsVM), true);
             $('#TextComment').val('');
             GetComments();

         }
         else {
             logger.logError('An error has occurred while saving comment. Please contact your Administrator.', 'Error', system.getModuleId(ActionItemDetailsVM), true);
         }
     })
     .fail(function (jsonResult, error) {

     })
            }

            else {

                document.getElementById('valcommenterror').innerHTML = "Please enter a comment.";
                $('#valcommenterror').show();
            }


        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveComment() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }


    function GetComments()
    {
        try{
            return $.ajax({
                url: "/api/ActionPlan/GetActionComments",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ActionItemId: ActionItemDetailsVM.ActionItemId(), CommentType: 'ATIC' }

            })
         .success(function (jsonResult, status) {
             var MappedColumnObject = $.map(jsonResult, function (result) {
                 if (result.CommentType.toUpperCase() == 'ATIC') {
                     return new CommentModel(result);
                 }
                 else {

                 }
             })
             
             var object = $('#tblcommentdetails').DataTable();
             ActionItemDetailsVM.CommentList([]);
             object.destroy();
             $('#tblcommentdetails tbody tr').remove();
             ActionItemDetailsVM.CommentList(MappedColumnObject);
             $("#tblcommentdetails").DataTable();
         })
         .fail(function (error, status) {
             if (error.status == 401) {
                 app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                 .then(function (option) {
                     if (option == "OK")
                         navigation.unauthorized();
                 })
             }
             else {
                 var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetComments() method in ActionItemDetails.js';
                 logger.logMessage(msg);
             }
         });
        }
        catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:GetallSurveyComments() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function GetallSurveyPushBackComments()
    {
        try{
            return $.ajax({
                url: "/api/ActionPlan/GetActionComments",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ActionItemId: ActionItemDetailsVM.ActionItemId(), CommentType: "ATIPBC" }

            })
.success(function (jsonResult, status) {
    

    if (jsonResult != null && jsonResult.length != 0 ) {

        var object = $('#tblFinalizecommentdetails').DataTable();
        ActionItemDetailsVM.SurveyFinalizeCommentList([]);
        var MappedColumnObject = $.map(jsonResult, function (result) {
            return new CommentModel(result);
        })
        object.destroy();
        $('#tblFinalizecommentdetails tbody tr').remove();
        ActionItemDetailsVM.SurveyFinalizeCommentList(MappedColumnObject);
        $("#tblFinalizecommentdetails").DataTable();
    }
    else {

        var object = $('#tblFinalizecommentdetails').DataTable();
        ActionItemDetailsVM.SurveyFinalizeCommentList([]);
        object.destroy();
        $('#tblFinalizecommentdetails tbody tr').remove();
        $("#tblFinalizecommentdetails").DataTable();

    }
})
.fail(function (error, status) {
    if (error.status == 401) {
        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
        .then(function (option) {
            if (option == "OK")
                navigation.unauthorized();
        })
    }
    else {
        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetallSurveyComments() method in ActionItemDetails.js';
        logger.logMessage(msg);
    }
});
        }
        catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:GetallSurveyPushBackComments() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function GetallSurveyDocuments() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetSurveyDocuments",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ActionItemId: ActionItemDetailsVM.ActionItemId() }

            })
         .success(function (jsonResult, status) {

             var MappedColumnObject = $.map(jsonResult, function (result) {
                 return new DocumentModel(result);

             })
             var object = $('#tblSurveydocumentdetails').DataTable();
             ActionItemDetailsVM.SurveyDocumentList([]);
             object.destroy();
             $('#tblSurveydocumentdetails tbody tr').remove();
             ActionItemDetailsVM.SurveyDocumentList(MappedColumnObject);
             $("#tblSurveydocumentdetails").DataTable();
         })
         .fail(function (error, status) {
             if (error.status == 401) {
                 app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                 .then(function (option) {
                     if (option == "OK")
                         navigation.unauthorized();
                 })
             }
             else {
                 var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetallSurveyDocuments() method in ActionItemDetails.js';
                 logger.logMessage(msg);
             }
         });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:GetallSurveyDocuments() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function GetSurveyComments() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetSurveyComments",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ActionItemId: ActionItemDetailsVM.ActionItemId() }

            })
                     .success(ajaxSuccess)
                     .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetSurveyComments() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length != 0 ) {

                    var object = $('#tblsurveycommentdetails').DataTable();
                    ActionItemDetailsVM.SurveyCommentList([]);
                    var MappedColumnObject = $.map(jsonResult, function (result) {
                        if (result.CommentType.toUpperCase() != 'ATIC') {
                            return new CommentModel(result);
                        }
                        else {

                        }
                    })
                    object.destroy();
                    $('#tblsurveycommentdetails tbody tr').remove();
                    ActionItemDetailsVM.SurveyCommentList(MappedColumnObject);
                    $("#tblsurveycommentdetails").DataTable();

                    //


                }
                else {

                    var object = $('#tblsurveycommentdetails').DataTable();
                    ActionItemDetailsVM.SurveyCommentList([]);
                    object.destroy();
                    $('#tblsurveycommentdetails tbody tr').remove();
                    $("#tblsurveycommentdetails").DataTable();

                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetComments() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetComments() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetComments() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };

    }

    function UploadDocument(data, event) {
        try {
            $("#valfactorerror").hide();

            if ($('#AttachmentCommentItem').val() == "") {
                $('#valfactorerror').show();
                $('#valfactorerror').html('Please add comment before upload');
                return false;
            }
            if ($('#AttachmentCommentItem').val().length > 100) {
                $('#valfactorerror').show();
                $('#valfactorerror').html('The comment length must not be greater then 100');
                return false;
            }
            var regexp = /^[A-Za-z0-9_&-|//}{\ ~!@#$%^&*()_+]+$/;
            if (!$('#AttachmentCommentItem').val().match(regexp)) {
                $('#valfactorerror').show();
                $('#valfactorerror').html('Please provide valid input for comment');
                return false;
            }
            $("#loadingImgDocument").show();
            var FileList = document.getElementById('FileUploader').files;
            if (FileList.length > 0) {
                var FileName = document.getElementById('FileUploader').files[0].name;
                if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'JPG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                        FileName.length).toUpperCase() == 'JPEG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                            FileName.length).toUpperCase() == 'DOCX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                FileName.length).toUpperCase() == 'DOC' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                    FileName.length).toUpperCase() == 'XLS' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                        FileName.length).toUpperCase() == 'XLSM' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                            FileName.length).toUpperCase() == 'BMP' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                FileName.length).toUpperCase() == 'RTF' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                    FileName.length).toUpperCase() == 'PDF' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                        FileName.length).toUpperCase() == 'XLSX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                            FileName.length).toUpperCase() == 'CSV' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                                FileName.length).toUpperCase() == 'TXT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                                    FileName.length).toUpperCase() == 'PPT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                                        FileName.length).toUpperCase() == 'PPTX') {
                    if (FileList[0].size <= 3145728) {

                        document.getElementById('valfactorerror').innerHTML = "";

                        var FormDataObj = new FormData();
                        FormDataObj.append("File1", FileList[0]);
                        var request = new XMLHttpRequest();
                        ActionItemDetailsVM.AttachmentComment($('#AttachmentCommentItem').val());

                        request.onreadystatechange = function () {
                            if (request.readyState == 4) {
                                if (request.status == 200) {
                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                        logger.logSuccess('Document has been saved successfully.', 'Success', system.getModuleId(ActionItemDetailsVM), true);
                                        $("#valfactorerror").hide();
                                        $('#AttachmentCommentItem').val("");
                                        $("#loadingImgDocument").hide();
                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                        document.getElementById('FileUploader').value = null;
                                        GetDocuments();
                                    }
                                    else {
                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                        $('#valfactorerror').show();
                                        document.getElementById('FileUploader').value = null;
                                        $("#loadingImgDocument").hide();
                                    }
                                }
                                else {
                                    ajaxFail(request, "");
                                    $("#loadingImgDocument").hide();
                                }
                            }
                        };
                         
                        request.withCredentials = true;
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        request.open('POST', '/api/ActionPlan/UploadDocument?ActionItemId=' + ActionItemDetailsVM.ActionItemId() + "&Comment=" + ActionItemDetailsVM.AttachmentComment());
                        request.setRequestHeader('Authorization', headers.Authorization);
                        request.setRequestHeader('RT', headers.RT);
                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                        request.send(FormDataObj);
                    }
                    else {
                        document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed " + (ActionItemDetailsVM.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                        $('#valfactorerror').show();
                    }
                }
                else
                    document.getElementById('valfactorerror').innerHTML = "Please select a valid file to upload";
            }

            else {
                document.getElementById('valfactorerror').innerHTML = "Please select a file to upload";
                $('#valfactorerror').show();
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK") {

                            }
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in ActionItemDetails.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            };

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }

    }

    function NavigateToDashboard() {
        try {

            router.navigate("#ActionTracker/ActionItemDashboard", true);
            return false;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }
    function NavigateToManagement() {
        try {

            router.navigate("#ActionTracker/ConfigureActionTracker", true);
            return false;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }
    function NavigateToActiontracking() {
        try {

            router.navigate("#ActionTracker/Actiontracking", true);
            return false;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }
    function GetDocuments() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetDocuments",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ActionItemId: ActionItemDetailsVM.ActionItemId() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetDocuments() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length != 0) {

                    var MappedColumnObject = $.map(jsonResult, function (result) {
                        return new DocumentModel(result);

                    })
                    var object = $('#tbldocumentdetails').DataTable();
                    ActionItemDetailsVM.DocumentList([]);
                    object.destroy();
                    $('#tbldocumentdetails tbody tr').remove();
                    ActionItemDetailsVM.DocumentList(MappedColumnObject);
                    $("#tbldocumentdetails").DataTable();
                    $("#ActionItemDocuments").show();

}
                else {
                    var object = $('#tbldocumentdetails').DataTable();
                    ActionItemDetailsVM.DocumentList([]);
                    object.destroy();
                    $('#tbldocumentdetails tbody tr').remove();
                    $("#tbldocumentdetails").DataTable();
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetDocuments() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetDocuments() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetDocuments() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };
    }

    function ActionItemDetails() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetActionItemDetails",
                type: "GET",
                data: { "ActionItemId": ActionItemDetailsVM.ActionItemId() },
                headers: appsecurity.getSecurityHeaders()
            })
                 .success(function (jsonResult, Success) {
                     if (jsonResult != null) {
                         if (jsonResult.length == 0) {


                             var mappedEnv = new ActionItemDetailsModel({ ActionItemTitle: null, ActionItemDescription: null, ControlArea: null, ControlDescription: null, Response: null, BusinessUnit: null })
                             ActionItemDetailsVM.ActionItemDetailsList([]);
                             ActionItemDetailsVM.ActionItemDetailsList(mappedEnv);
                         }
                         else {

                             var MappedList = $.map(jsonResult, function (result) {
                                 return new ActionItemDetailsModel(result);
                             });
                             ActionItemDetailsVM.ActionItemDetailsList(MappedList[0]);
                             //  $('#ActionItemStatus').val(ActionItemDetailsVM.ActionItemDetailsList().Status())
                             if (jsonResult[0].Assignees != null)
                                 ActionItemDetailsVM.Assignees(jsonResult[0].Assignees);
                             else
                                 ActionItemDetailsVM.Assignees(["No Asignee assigned"]);
                             if (jsonResult[0].Reviewers != null)
                                 ActionItemDetailsVM.Reviewers(jsonResult[0].Reviewers);
                             else
                                 ActionItemDetailsVM.Reviewers(["No Reviewer assigned"]);
                         }
                         $('#FromDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
                         $('#FromDate1').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
                     }
                 })
                 .fail(function (jsonResult, error) {
                     logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ActionItemDetailsVM), true);

                 });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in ActionItemDetails() method in    ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function GetActionItemAction() {
        try {
            $.ajax({
                url: "/api/ActionPlan/GetActionsList?ActionItemId=" + ActionItemDetailsVM.ActionItemId() + "&RoleId=" + ActionItemDetailsVM.RoleId() + "&TableKey=" + "ACTION ITEM",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetActionItemAction() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                ActionItemDetailsVM.ActionItemActionsList([]);
                if (jsonResult != null) {
                    var mappedActionsList = $.map(jsonResult, function (result) {
                        return new ActionItemActionsModel(result);
                    });
                    ActionItemDetailsVM.ActionItemActionsList(mappedActionsList);

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetActionItemAction() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetActionItemAction() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetActionItemAction() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };
    }
    function PerformSelectedAction(data, event) {
        try {
            if (ActionItemDetailsVM.PushbackComment()==undefined||ActionItemDetailsVM.PushbackComment().length == 0) {
                $('#valcommenttexterror').show();
                $("#valcommenttexterror").html("Please enter comments to perform the selected action")
            }
            else if ($('#FinalizeSelectStatus option:selected').text() == "Select")
            {
                $('#valcommenttexterror').show();
                $("#valcommenttexterror").html("Please enter some valid action to perform")
            }
            else {
                $('#valcommenttexterror').hide();
                SavePushbackComment();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:PerformSelectedAction() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function SavePushbackComment() {
        try {
            $("#loadingImgFinalize").show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                //change the url
                url: "/api/ActionPlan/SavePushBackComment?ActionItemId=" + ActionItemDetailsVM.ActionItemId() + "&CommentText=" + ActionItemDetailsVM.PushbackComment(),
                headers: headers,
                type: "POST",
                //async: false
            })
                .success(function (jsonResult, status) {
                    if (jsonResult != null) {
                        UpdateStatus();
                        $('#valcommenttexterror').hide();
                    }
                    else {
                        $("#loadingImgFinalize").hide();
                        $('#valcommenttexterror').hide();
                        logger.logError('An error has occurred while saving comment. Please contact your Administrator.', 'Error', system.getModuleId(ActionItemDetailsVM), true);
                    }
                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SavePushbackComment() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }
    function UpdateStatus() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/ActionPlan/SetPerformAction?EventId=" + ActionItemDetailsVM.EventId() + "&ActionItemId=" + ActionItemDetailsVM.ActionItemId() + "&TableKey=" + "ACTR.ACTION_ITEM_MASTER",
                headers: headers,
                type: "POST",
                //async: false
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateStatus() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {
                    $("#loadingImgFinalize").hide();
                    $("#FinalizeComment").val("");
                    $('#FinalizeSelectStatus').val('')
                    logger.logSuccess('Action has been performed successfully.', 'Success', system.getModuleId(ActionItemDetailsVM), true);
                    setTimeout(router.navigate('ActionTracker/ActionItemDashboard', true), 200);
                    //router.navigate('survey/SurveyDashBoard', true);
                }
                else if (jsonResult < 1) {
                    $("#loadingImgFinalize").hide();
                    logger.logError('An error occurred while performing selected action.', 'Error', system.getModuleId(ActionItemDetailsVM), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateStatus() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };
    }

    function DownloadDocument(data) {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), FilePath: data.DDOC_LOCATION(), FileId: data.DDOC_UID().toString() + ActionItemDetailsVM.ActionItemId().toString(), FileName: data.DDOC_ORIG_NAME()
            };
            utils.postAndRedirect(rootPath + "/FileDownload/DownloadActionDetailsDocument", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownloadDocument() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }
    function DeleteDocument(data, event) {
        try {
            $("#loadingImgDocument").show();

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/DeleteItemAttachment",
                type: "POST",
                headers: headers,
                data: { AIM_UID: ActionItemDetailsVM.ActionItemId(), DocumentName: data.DDOC_ORIG_NAME(), DocumentLocation: data.DDOC_LOCATION(), DocumentId: data.DDOC_UID(), DocuSubLocation: data.DDOC_LOCATION() + data.DDOC_UID() + ActionItemDetailsVM.ActionItemId() + '.' + data.DDOC_ORIG_NAME().split('.').pop() }
            })
              .success(function (jsonResult, error) {
                    if (jsonResult != undefined && jsonResult == "NotFound") {
                        $("#loadingImgDocument").hide();
                        logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                    }
                    else if (jsonResult != undefined && jsonResult != "-1") {
                        $("#loadingImgDocument").hide();
                        logger.logSuccess('File Deleted Successfully ', 'Success', system.getModuleId(ActionPlanDetailsVM), true);
                        GetDocuments();
                    } else {
                        $("#loadingImgDocument").hide();
                        logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(ActionPlanDetailsVM), true);
                    }

                })
                .fail(function (jsonResult, error) {
                    $("#loadingImgDocument").hide();
                    logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | DeleteAttachment() in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }

    function DownloadSurveyDocument(data)
    {
        try{
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), FilePath: data.DDOC_LOCATION(), FileName: data.DDOC_LOCATION()
            };
            utils.postAndRedirect(rootPath + "/FileDownload/DownloadFile", payLoad, '_blank');
        }
        catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: DownloadSurveyDocument() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }
    function UpdateActionItemStatus() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/ActionPlan/UpdateActionItemDetails",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ ActionItemId: ActionItemDetailsVM.ActionItemId(), ActionItemDescription: ActionItemDetailsVM.ActionItemDetailsList().ActionItemDescription(), ActionItemTitle: ActionItemDetailsVM.ActionItemDetailsList().ActionItemTitle(), ActualEndDate: ActionItemDetailsVM.ActionItemDetailsList().ActualEndDate(), ActualStartDate: ActionItemDetailsVM.ActionItemDetailsList().ActualStartDate(), BusinessUnit: ActionItemDetailsVM.ActionItemDetailsList().BusinessUnit, ControlArea: ActionItemDetailsVM.ActionItemDetailsList().ControlArea, ControlQuestion: ActionItemDetailsVM.ActionItemDetailsList().ControlQuestion, CreatedBy: ActionItemDetailsVM.ActionItemDetailsList().CreatedBy, CreatedDate: ActionItemDetailsVM.ActionItemDetailsList().CreatedDate, EstimatedEndDate: ActionItemDetailsVM.ActionItemDetailsList().EstimatedEndDate(), EstimatedStartDate: ActionItemDetailsVM.ActionItemDetailsList().EstimatedStartDate(), Response: ActionItemDetailsVM.ActionItemDetailsList().Response, Status: ActionItemDetailsVM.ActionItemDetailsList().Status(), WorkflowStatus: ActionItemDetailsVM.ActionItemDetailsList().WorkflowStatus })

            })

        .success(ajaxSuccess)
        .fail(ajaxFail);
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateActionItemStatus() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {
                    logger.logSuccess('Action Details are updated successfully.', 'Success', system.getModuleId(ActionItemDetailsVM), true);

                }
                else if (jsonResult < 1)
                    logger.logError('An error occurred while performing selected action.', 'Error', system.getModuleId(ActionItemDetailsVM), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateStatus() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };



        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateStatus() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        };
    }


    //function btnClickPerformAction(data, event) {
    //    try {
    //        if ($('input[name=rdbAction]:checked').val() != undefined) {
    //            $('#divActionError').hide();
    //            SetComments(null, "PBC", SrViewModel.PushbackComment());
    //            UpdateStatus();
    //        }
    //        else {
    //            $('#divActionError').show();
    //        }
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: btnClickPerformAction() method in SurveyResponse.js';
    //        logger.logMessage(msg);
    //    }
    //}

    function CommentModel(item) {
        try {
            var self = this;
            self.AIM_UID = ko.observable(item.ActionItemId);
            self.DCOM_UID = ko.observable(item.CommentId);
            self.DCOM_COMMENT = ko.observable(item.CommentText);
            self.DCOM_TYPE = ko.observable($('<div/>').html(item.CommentType).text());
            self.DCOM_CREATE_UID = ko.observable(item.CreateId);
            self.DCOM_CREATE_DATE = ko.observable($('<div/>').html(item.CreateDate).text());
            self.USERNAME = ko.observable($('<div/>').html(item.USERNAME).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CommentModel() method in ActionItemDetails.js';
            logger.logMessage(msg);


        }
    }


    function DocumentModel(item) {
        try {
            var self = this;

            self.DDOC_ORIG_NAME = ko.observable($('<div/>').html(item.DDOC_ORIG_NAME).text());
            self.DDOC_CREATE_UID = ko.observable(item.DDOC_CREATE_UID);
            self.DDOC_LOCATION = ko.observable(item.DDOC_LOCATION);
            self.DDOC_CREATE_DATE = ko.observable($('<div/>').html(item.DDOC_CREATE_DATE).text());
            self.USERNAME = ko.observable($('<div/>').html(item.USERNAME).text());
            self.DDOC_UID = ko.observable(item.DDOC_UID);
            self.Comment = ko.observable(item.Comment);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DocumentModel() method in ActionItemDetails.js';
            logger.logMessage(msg);


        }
    }
    function validatetext(item) {
        if (item == null || item == undefined || item.length == 0) {
            return "-"
        }
        else {
            return item
        }
    }
    function ActionItemDetailsModel(item) {
        var self = this;

        self.ActionItemTitle = ko.observable($('<div/>').html(validatetext(item.ActionItemTitle)).text());

        self.ActionItemDescription = ko.observable($('<div/>').html(validatetext(item.ActionItemDescription)).text());

        self.ControlArea = ko.observable($('<div/>').html(validatetext(item.ControlArea)).text());


        if (item.ControlQuestion == null || item.ControlQuestion == undefined || item.ControlQuestion.length == 0) {
            self.ControlQuestion = ko.observable("-");
            self.ControlQuestionshort = ko.observable("-");
        }
        else {
            self.ControlQuestion = ko.observable($('<div/>').html(item.ControlQuestion).text());
            if (item.ControlQuestion.length < 50) {
                self.ControlQuestionshort = ko.observable(item.ControlQuestion);
            }
            else {
                self.ControlQuestionshort = ko.observable(item.ControlQuestion.substring(0, 50) + '...');
            }

        }
        self.Response = ko.observable($('<div/>').html(validatetext(item.Response)).text());

        self.BusinessUnit = ko.observable($('<div/>').html(validatetext(item.BusinessUnit)).text());

        self.WorkflowStatus = ko.observable($('<div/>').html(validatetext(item.WorkflowStatus)).text());
        self.ActualStartDate = ko.observable($('<div/>').html(validatetext(item.ActualStartDate)).text());
        self.ActualEndDate = ko.observable($('<div/>').html(validatetext(item.ActualEndDate)).text());

        self.Status = ko.observable($('<div/>').html(validatetext(item.Status)).text());

        self.EstimatedStartDate = ko.observable($('<div/>').html(validatetext(item.EstimatedStartDate)).text());

        self.EstimatedEndDate = ko.observable($('<div/>').html(validatetext(item.EstimatedEndDate)).text());

        self.CreatedBy = ko.observable($('<div/>').html(validatetext(item.CreatedBy)).text());

        self.CreatedDate = ko.observable($('<div/>').html(validatetext(item.CreatedDate)).text());


        self.AssessmentProfile = ko.observable($('<div/>').html(validatetext(item.AssessmentProfile)).text());
        self.AssessmentType = ko.observable($('<div/>').html(validatetext(item.AssessmentType)).text());
    }

    function ActionItemActionsModel(item) {
        try {
            var self = this;
            self.EventId = ko.observable(item.EventId);
            self.EventName = ko.observable($('<div/>').html(item.EventName).text());
            self.NextState = ko.observable($('<div/>').html(item.NextState).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionItemActionsModel() method in ActionItemDetails.js';
            logger.logMessage(msg);
        }
    }



});
